export const MAX_REQUEST_WAIT = 5000;
export const IN_THIRTY_MINUTES = new Date(new Date().getTime() + 30 * 60000);
export const IN_ONE_YEAR = new Date(new Date().getTime() + 24 * 3600000 * 365);
export const TIMEOUT_TICK = 1000;
export const COMPARA_COOKIES_USER_ID = "comparaUserId";
export const COMPARA_COOKIES_SESSION_ID = "compara.session.id";
